export default "__VITE_ASSET__bf9f786a__"